import { getFormattedAmount } from '@zonofi/common';
interface LedgerRowOpeningProps {
  date: string;
  debit: number | undefined;
  credit: number | undefined;
  isTrialBalanceLoading?: boolean;
}

export const LedgerRowOpening: React.FC<LedgerRowOpeningProps> = ({
  date,
  debit,
  credit,
  isTrialBalanceLoading = false,
}) => {
  return (
    <div className="ledger-grid ledger-view-opening font-semibold font-primary-semibold">
      <div className="ledger-view-opening-ledger">
        <span className="ledger-view-opening-ledger-date">{date}</span>
        <span className="ledger-view-opening-ledger-info font-regular font-primary-regular">
          Opening Balance
        </span>
      </div>
      <span className="ledger-view-opening-text debit">
        {debit ? getFormattedAmount(Math.abs(debit), true) : '-'}
      </span>
      <span className="ledger-view-opening-text credit">
        {credit ? getFormattedAmount(Math.abs(credit), true) : '-'}
      </span>
    </div>
  );
};
